import React from 'react';

// A list of labelled checkboxes, one for each { value, label } option. selectedValues holds the values of the ticked
// ones; onChange gets the new list whenever a box is ticked or unticked.
export default function CheckboxList({
  options = [],
  selectedValues = [],
  disabled = false,
  onChange = (newSelectedValues) => {},
}) {
  function toggle(value, isTicked) {
    const newSelectedValues = isTicked
      ? [...selectedValues, value]
      : selectedValues.filter((selectedValue) => selectedValue !== value);
    onChange(newSelectedValues);
  }

  return (
    <div className='d-flex flex-column gap-1'>
      {options.map((option) => (
        <label
          key={option.value}
          className='d-flex align-items-center gap-2'
        >
          <input
            type='checkbox'
            className='inputCheckBox'
            checked={selectedValues.includes(option.value)}
            disabled={disabled}
            onChange={(e) => toggle(option.value, e.target.checked)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}
